import { Avatar as MUIAvatar, AvatarProps, useTheme } from '@mui/material';
import { forwardRef } from 'react';

type AvatarColor =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'info'
  | 'success'
  | 'warning'
  | 'error';

export interface Props extends AvatarProps {
  color?: AvatarColor;
}

export const Avatar = forwardRef<HTMLDivElement, Props>(
  ({ color = 'default', children, sx, ...other }, ref: any) => {
    const theme = useTheme();

    if (color === 'default') {
      return (
        <MUIAvatar
          ref={ref}
          sx={sx}
          data-testid="ysura_component-library_avatar"
          {...other}
        >
          {children}
        </MUIAvatar>
      );
    }

    return (
      <MUIAvatar
        ref={ref}
        sx={{
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette[color].contrastText,
          backgroundColor: theme.palette[color].main,
          ...sx,
        }}
        data-testid="ysura_component-library_avatar"
        {...other}
      >
        {children}
      </MUIAvatar>
    );
  }
);
